import React, { AriaAttributes } from 'react';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

export type Props = NextLinkProps & {
  children: React.ReactNode;
  'aria-current'?: AriaAttributes['aria-current'];
  className?: string;
  'aria-label'?: AriaAttributes['aria-label'];
  target?: JSX.IntrinsicElements['a']['target'];
  rel?: JSX.IntrinsicElements['a']['rel'];
  role?: JSX.IntrinsicElements['a']['role'];
  onClick?: JSX.IntrinsicElements['a']['onClick'];
  'data-testid'?: string;
};

export const Link: React.FC<Props> = ({
  'aria-current': ariaCurrent,
  'aria-label': ariaLabel,
  className,
  target,
  rel,
  role,
  onClick,
  'data-testid': testId,
  children,
  ...props
}) => (
  <NextLink {...props} passHref data-testid={testId}>
    <a
      aria-current={ariaCurrent}
      aria-label={ariaLabel}
      className={className}
      target={target}
      rel={rel}
      role={role}
      onClick={onClick}
    >
      {children}
    </a>
  </NextLink>
);
